import request from "@/utils/request";

// 轮播数据
export const getSwiperList = async() => {
  return request.get(`/pictureNews/page`);
}


// 首页获取通知公告
export const getNoticeList = (data: any) => {
  return request.get(`/newsAnnouncement/page?pageNum=${data.pageNum}&pageSize=${data.pageSize}&type=${data.type}&category=${data.category}`)
}
// 条件查询
// export const getNoticeSearch = (data: any) => {
//   return request.get(`/newsAnnouncement/seach?title=${data.title}&type=${data.type}`)
// }
export const getNoticeSearch = (data: any) => {
  return request.get(`/newsAnnouncement/seach?title=${data.title}&type=${data.type}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`)
}